// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"tp-z","selected":"up-z"};